var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductHostingTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEA\xB2\xA9\xEB\xA6\xAC_\xEB\xAA\xA8\xEB\x93\x9C",
    clipPath: "url(#clip0_2881_52665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.431 25.8187C44.0947 14.5329 37.105 3.22454 25.8192 0.560842C14.5334 -2.10286 3.22504 4.88677 0.561336 16.1726C-2.10236 27.4584 4.88726 38.7668 16.1731 41.4305C27.4589 44.0942 38.7673 37.1046 41.431 25.8187Z",
    fill: "url(#paint0_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 11.1865C0 12.259 0.901224 13.1081 1.96631 13.1081C2.81539 13.1081 5.10197 13.1081 5.10197 13.1081C5.10197 13.1081 3.87303 11.41 3.87303 11.1865C3.87303 10.114 3.00904 9.25 1.93651 9.25C0.863983 9.25 0 10.114 0 11.1865Z",
    fill: "url(#paint1_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.88025 9.99472C6.64191 8.78067 5.56938 7.872 4.28086 7.8869C2.94764 7.9018 1.72615 9.12329 1.71125 10.4565C1.68891 11.9163 2.86571 13.1006 4.3181 13.1006H6.8728C7.48355 13.1006 8.06451 12.7133 8.20602 12.1174C8.36988 11.4471 7.95278 10.7917 7.35693 10.5757C7.1037 10.4788 6.93239 10.2629 6.88025 10.0022V9.99472Z",
    fill: "url(#paint2_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.0004 11.1865C42.0004 12.259 41.0992 13.1081 40.0341 13.1081C39.185 13.1081 36.8984 13.1081 36.8984 13.1081C36.8984 13.1081 38.1274 11.41 38.1274 11.1865C38.1274 10.114 38.9914 9.25 40.0639 9.25C41.1364 9.25 42.0004 10.114 42.0004 11.1865Z",
    fill: "url(#paint3_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.1195 9.99472C35.3578 8.78067 36.4303 7.872 37.7189 7.8869C39.0521 7.9018 40.2736 9.12329 40.2885 10.4565C40.3108 11.9163 39.134 13.1006 37.6816 13.1006H35.1269C34.5162 13.1006 33.9352 12.7133 33.7937 12.1174C33.6298 11.4471 34.0469 10.7917 34.6428 10.5757C34.896 10.4788 35.0673 10.2629 35.1195 10.0022V9.99472Z",
    fill: "url(#paint4_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M31.7521 4.57227H10.2419C9.97456 4.57227 9.75781 4.78902 9.75781 5.05639V9.19755C9.75781 9.46493 9.97456 9.68168 10.2419 9.68168H31.7521C32.0195 9.68168 32.2363 9.46493 32.2363 9.19755V5.05639C32.2363 4.78902 32.0195 4.57227 31.7521 4.57227Z",
    fill: "url(#paint5_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.2347 4.57227H10.2494C9.9779 4.57227 9.75781 4.79235 9.75781 5.06384V9.19011C9.75781 9.4616 9.9779 9.68168 10.2494 9.68168H29.2347C29.5062 9.68168 29.7262 9.4616 29.7262 9.19011V5.06384C29.7262 4.79235 29.5062 4.57227 29.2347 4.57227Z",
    fill: "url(#paint6_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M28.6082 5.37695H10.8668C10.6858 5.37695 10.5391 5.52368 10.5391 5.70467V8.54986C10.5391 8.73085 10.6858 8.87757 10.8668 8.87757H28.6082C28.7892 8.87757 28.9359 8.73085 28.9359 8.54986V5.70467C28.9359 5.52368 28.7892 5.37695 28.6082 5.37695Z",
    fill: "url(#paint7_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.8742 8.87013V5.88343C10.8742 5.77915 10.9562 5.69722 11.0604 5.69722H28.9359C28.9359 5.51847 28.787 5.37695 28.6082 5.37695H10.8668C10.688 5.37695 10.5391 5.52592 10.5391 5.70467V8.54986C10.5391 8.72861 10.688 8.87757 10.8668 8.87757H10.8742C10.8742 8.87757 10.8742 8.87757 10.8742 8.87013Z",
    fill: "url(#paint8_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.4007 2.30859H15.3281V4.58027H16.4007V2.30859Z",
    fill: "url(#paint9_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.4007 2.30859H15.3281V3.53009H16.4007V2.30859Z",
    fill: "url(#paint10_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M27.7132 2.30859H26.6406V4.58027H27.7132V2.30859Z",
    fill: "url(#paint11_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M27.7132 2.30859H26.6406V3.53009H27.7132V2.30859Z",
    fill: "url(#paint12_linear_2881_52665)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.5283 7.57478L12.4538 7.94718H12.1484L12.5059 6.30859H12.8858L13.2061 7.94718H12.9007L12.8337 7.57478H12.5432H12.5283ZM12.7964 7.32899L12.7443 6.98637C12.7294 6.88955 12.707 6.72569 12.6922 6.61397C12.6773 6.72569 12.6475 6.88955 12.6326 6.98637L12.573 7.32899H12.8039H12.7964Z",
    fill: "#AEF4DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M14.7422 6.33839C14.839 6.31604 14.9656 6.30859 15.0922 6.30859C15.2636 6.30859 15.42 6.33094 15.5317 6.42776C15.6285 6.51714 15.6583 6.62886 15.6583 6.77038C15.6583 6.94168 15.5764 7.10554 15.4051 7.18002C15.5168 7.23216 15.5689 7.33644 15.6062 7.50774C15.636 7.6865 15.6807 7.89505 15.7104 7.95463H15.3753C15.3529 7.90994 15.3231 7.74608 15.2933 7.56733C15.2636 7.36623 15.2114 7.30664 15.1071 7.30664H15.0625V7.96208H14.7422V6.35328V6.33839ZM15.0625 7.05341H15.122C15.2636 7.05341 15.338 6.94168 15.338 6.80017C15.338 6.65866 15.2859 6.56183 15.1369 6.55438C15.1071 6.55438 15.0774 6.55438 15.0625 6.56183V7.05341Z",
    fill: "#AEF4DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M17.2344 6.33839C17.3312 6.31604 17.4578 6.30859 17.5844 6.30859C17.7557 6.30859 17.9122 6.33094 18.0239 6.42776C18.1207 6.51714 18.1505 6.62886 18.1505 6.77038C18.1505 6.94168 18.0686 7.10554 17.8973 7.18002C18.009 7.23216 18.0611 7.33644 18.0984 7.50774C18.1282 7.6865 18.1728 7.89505 18.2026 7.95463H17.8675C17.8451 7.90994 17.8153 7.74608 17.7855 7.56733C17.7557 7.36623 17.7036 7.30664 17.5993 7.30664H17.5546V7.96208H17.2344V6.35328V6.33839ZM17.5546 7.05341H17.6068C17.7483 7.05341 17.8228 6.94168 17.8228 6.80017C17.8228 6.65866 17.7706 6.56183 17.6217 6.55438C17.5919 6.55438 17.5621 6.55438 17.5472 6.56183V7.05341H17.5546Z",
    fill: "#AEF4DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M20.0586 6.31641V7.955H19.7383V6.31641H20.0586Z",
    fill: "#AEF4DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M21.8962 7.955L21.5312 6.31641H21.8813L22.0005 7.02398C22.0303 7.19529 22.0601 7.40383 22.0824 7.59004C22.1048 7.39638 22.1345 7.20273 22.1569 7.01653L22.2686 6.31641H22.6187L22.2463 7.955H21.8888H21.8962Z",
    fill: "#AEF4DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M24.3877 7.57478L24.3132 7.94718H24.0078L24.3653 6.30859H24.7452L25.0654 7.94718H24.7601L24.693 7.57478H24.4026H24.3877ZM24.6484 7.32899L24.5962 6.98637C24.5813 6.88955 24.559 6.72569 24.5441 6.61397C24.5292 6.72569 24.4994 6.88955 24.4845 6.98637L24.4249 7.32899H24.6558H24.6484Z",
    fill: "#AEF4DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M26.5898 6.31641H26.9101V7.68686H27.3272V7.955H26.5898V6.31641Z",
    fill: "#AEF4DB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M9.52216 20.7808L9.14975 21.1532L8.77734 20.7808L9.10506 17.012C9.10506 16.9673 9.17954 16.9673 9.18699 17.012L9.51471 20.7808H9.52216Z",
    fill: "url(#paint13_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M41.6898 24.5787V24.2361C41.6898 20.9738 39.0457 18.3223 35.776 18.3223H33.6458C33.266 18.3223 32.9531 18.6351 32.9531 19.0149V23.1487C32.9531 23.8413 32.3945 24.3999 31.7019 24.3999H26.7116C21.7065 24.3999 16.9992 26.7759 14.02 30.7979H13.156V30.1722H12.3665C12.1133 30.1722 11.9122 29.9711 11.9122 29.7179V29.0103C11.9122 28.5337 11.5249 28.1538 11.0556 28.1538C10.5417 28.1538 10.1172 27.7665 10.065 27.2526L9.69263 23.4987C9.67773 23.3498 9.7969 23.2306 9.94587 23.2157C10.1768 23.1859 10.3704 23.022 10.4374 22.7911L10.8769 21.2717C10.8992 21.2047 10.8471 21.1451 10.7801 21.1451H7.42095C7.35392 21.1451 7.30178 21.2121 7.32413 21.2717L7.71143 22.6273C7.79336 22.9103 8.11363 23.1338 8.38921 23.2306C8.47114 23.2604 8.51583 23.3423 8.50838 23.4242L7.77846 30.8277C7.77846 30.8798 7.72633 30.9171 7.67419 30.9171H7.01875C6.33353 30.9171 5.68554 31.1852 5.20141 31.6693L4.70983 32.1609C4.70983 32.1609 4.66514 32.1907 4.63535 32.1907H3.25C6.97406 38.0747 13.5284 41.9775 20.9989 41.9775C31.3741 41.9775 39.9842 34.4549 41.6898 24.5638V24.5787Z",
    fill: "url(#paint14_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M8.46563 22.3366H9.03914V21.1523H8.24219L8.46563 22.3366Z",
    fill: "url(#paint15_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M9.94539 21.1523H9.14844V22.3366H9.72939L9.94539 21.1523Z",
    fill: "url(#paint16_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M8.13034 21.1523H7.28125L7.62386 22.3366H8.34633L8.13034 21.1523Z",
    fill: "url(#paint17_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M10.0558 21.1523L9.83984 22.3366H10.5698L10.9049 21.1523H10.0558Z",
    fill: "url(#paint18_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M7.49714 20.6309H10.6998C10.8637 20.6309 10.9978 20.7649 10.9978 20.9288V21.0777C10.9978 21.115 10.968 21.1448 10.9307 21.1448H7.26625C7.22901 21.1448 7.19922 21.115 7.19922 21.0777V20.9288C7.19922 20.7649 7.33329 20.6309 7.49714 20.6309Z",
    fill: "url(#paint19_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M9.39211 34.5375C9.39211 33.964 9.00481 33.4799 8.47599 33.3309C8.30468 33.2788 8.17061 33.1447 8.11848 32.9734C7.95462 32.4297 7.43325 32.0349 6.8225 32.0796C6.21176 32.1243 5.72018 32.6084 5.6606 33.2117C5.65315 33.3086 5.6606 33.4054 5.6606 33.4948C5.68294 33.681 5.60101 33.8746 5.43715 33.9789C5.09454 34.2023 4.87109 34.5896 4.87109 35.0291C4.87109 35.3791 5.01261 35.6994 5.25095 35.9303C5.32543 36.0048 5.39991 36.0942 5.43715 36.191C5.57122 36.5113 5.89149 36.7347 6.26389 36.7347C6.30113 36.7347 6.33837 36.7347 6.38306 36.7347C6.58416 36.7049 6.79271 36.7421 6.96402 36.8464C7.15022 36.9581 7.37367 37.0252 7.61201 37.0252C8.30468 37.0252 8.87074 36.4591 8.87074 35.7664C8.87074 35.7664 8.87074 35.7664 8.87074 35.759C8.87074 35.6398 8.91543 35.5281 9.00481 35.4387C9.2357 35.2078 9.38466 34.895 9.38466 34.545L9.39211 34.5375Z",
    fill: "url(#paint20_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M8.06718 35.417C8.05229 35.4542 8.02994 35.4915 8.0076 35.5213C7.98525 35.5511 7.94801 35.5809 7.91822 35.6032C7.88843 35.6255 7.84374 35.6404 7.8065 35.6628L7.62029 35.7522C7.62029 35.7522 7.63519 35.7298 7.63519 35.7149C7.65009 35.6777 7.65754 35.633 7.66498 35.5957L7.73202 35.35L7.65754 35.5883C7.64264 35.6255 7.63519 35.6702 7.62029 35.7075C7.62029 35.7224 7.6054 35.7447 7.59795 35.7596H7.58305V35.7671C7.57561 35.7671 7.57561 35.782 7.58305 35.7894C7.58305 35.7968 7.57561 35.8043 7.56816 35.8117C7.54581 35.8415 7.50857 35.8713 7.47878 35.8937C7.44899 35.916 7.4043 35.9309 7.36706 35.9533L7.16596 36.0501L7.15106 34.918L7.12872 36.4001L7.017 36.3406C6.97231 36.3182 6.92762 36.2884 6.89038 36.2512C6.85314 36.2139 6.82335 36.1693 6.80845 36.1246C6.801 36.1022 6.79355 36.0799 6.7861 36.0501C6.77866 36.0203 6.75631 35.9979 6.73397 35.9831C6.71162 35.9682 6.68183 35.9533 6.65949 35.9458C6.63714 35.9458 6.60735 35.9309 6.585 35.9235C6.54032 35.9086 6.49563 35.8639 6.48073 35.8192C6.45094 35.7149 6.42859 35.6106 6.40625 35.5138C6.42859 35.6181 6.45094 35.7224 6.47328 35.8266C6.48818 35.8788 6.53287 35.9235 6.585 35.9384C6.60735 35.9458 6.63714 35.9533 6.65949 35.9607C6.68183 35.9607 6.71162 35.9756 6.72652 35.9905C6.74886 36.0054 6.76376 36.0277 6.77121 36.0501C6.77866 36.0724 6.7861 36.1022 6.79355 36.1246C6.80845 36.1767 6.83824 36.2214 6.87548 36.2661C6.91272 36.3033 6.95741 36.3406 7.00955 36.3629L7.13617 36.4299V36.7353C7.13617 36.7353 7.16596 36.7651 7.1883 36.78V36.0799L7.3894 35.9682C7.42664 35.9458 7.46388 35.9309 7.50112 35.9086C7.53837 35.8862 7.56816 35.8564 7.5905 35.8192C7.5905 35.8117 7.6054 35.8043 7.6054 35.7894L7.82884 35.6702C7.82884 35.6702 7.90332 35.633 7.94056 35.6106C7.97781 35.5883 8.0076 35.5585 8.02994 35.5213C8.05229 35.484 8.07463 35.4468 8.08953 35.4095C8.10442 35.3723 8.11187 35.3276 8.11932 35.2904L8.18635 35.0446L8.11187 35.2829C8.09698 35.3202 8.08953 35.3649 8.07463 35.4021L8.06718 35.417Z",
    fill: "url(#paint21_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M18.271 34.5375C18.271 33.964 17.8837 33.4799 17.3549 33.3309C17.1836 33.2788 17.0495 33.1447 16.9974 32.9734C16.8335 32.4297 16.3122 32.0349 15.7014 32.0796C15.0907 32.1243 14.5991 32.6084 14.5395 33.2117C14.5321 33.3086 14.5395 33.4054 14.5395 33.4948C14.5618 33.681 14.4799 33.8746 14.3161 33.9789C13.9734 34.2023 13.75 34.5896 13.75 35.0291C13.75 35.3791 13.8915 35.6994 14.1299 35.9303C14.2043 36.0048 14.2788 36.0942 14.3161 36.191C14.4501 36.5113 14.7704 36.7347 15.1428 36.7347C15.18 36.7347 15.2173 36.7347 15.262 36.7347C15.4631 36.7049 15.6716 36.7421 15.8429 36.8464C16.0291 36.9581 16.2526 37.0252 16.4909 37.0252C17.1836 37.0252 17.7496 36.4591 17.7496 35.7664C17.7496 35.7664 17.7496 35.7664 17.7496 35.759C17.7496 35.6398 17.7943 35.5281 17.8837 35.4387C18.1146 35.2078 18.2636 34.895 18.2636 34.545L18.271 34.5375Z",
    fill: "url(#paint22_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M16.9755 35.2978C16.9606 35.3351 16.9532 35.3798 16.9383 35.417C16.9234 35.4542 16.901 35.4915 16.8787 35.5213C16.8563 35.5511 16.8266 35.5809 16.7893 35.6032C16.7595 35.6255 16.7148 35.6404 16.6776 35.6628L16.4914 35.7522C16.4914 35.7522 16.5063 35.7298 16.5063 35.7149C16.5212 35.6777 16.5286 35.633 16.5361 35.5957L16.6031 35.35L16.5286 35.5883C16.5137 35.6255 16.5063 35.6702 16.4914 35.7075C16.4914 35.7224 16.4765 35.7447 16.469 35.7596H16.4541V35.7671C16.4467 35.7671 16.4467 35.782 16.4541 35.7894C16.4541 35.7968 16.4467 35.8043 16.4393 35.8117C16.4169 35.8415 16.3871 35.8713 16.3499 35.8937C16.3201 35.916 16.2754 35.9309 16.2382 35.9533L16.0371 36.0501L16.0222 34.918L15.9998 36.4001L15.8881 36.3406C15.8434 36.3182 15.7987 36.2884 15.7615 36.2512C15.7242 36.2139 15.6944 36.1693 15.6795 36.1246C15.6721 36.1022 15.6646 36.0799 15.6572 36.0501C15.6498 36.0203 15.6274 35.9979 15.6051 35.9831C15.5827 35.9682 15.5529 35.9533 15.5306 35.9458C15.5082 35.9458 15.4784 35.9309 15.4561 35.9235C15.4114 35.9086 15.3667 35.8639 15.3518 35.8192C15.322 35.7149 15.2997 35.6106 15.2773 35.5138C15.2997 35.6181 15.322 35.7224 15.3444 35.8266C15.3593 35.8788 15.404 35.9235 15.4561 35.9384C15.4859 35.9458 15.5082 35.9533 15.5306 35.9607C15.5529 35.9607 15.5827 35.9756 15.5976 35.9905C15.62 36.0054 15.6349 36.0277 15.6423 36.0501C15.6423 36.0724 15.6572 36.1022 15.6646 36.1246C15.6795 36.1767 15.7093 36.2214 15.7466 36.2661C15.7838 36.3033 15.8285 36.3406 15.8806 36.3629L16.0073 36.4299L15.9626 39.4017C15.9626 39.439 15.9924 39.4688 16.0296 39.4688C16.0668 39.4688 16.0966 39.439 16.0966 39.4017L16.0519 36.0799L16.2679 35.9682C16.2679 35.9682 16.3424 35.9309 16.3797 35.9086C16.4169 35.8862 16.4467 35.8564 16.469 35.8192C16.469 35.8117 16.4839 35.8043 16.4839 35.7894L16.7074 35.6702C16.7074 35.6702 16.7819 35.633 16.8191 35.6106C16.8563 35.5883 16.8861 35.5585 16.9085 35.5213C16.9308 35.484 16.9532 35.4468 16.9681 35.4095C16.983 35.3723 16.9904 35.3276 16.9979 35.2904L17.0649 35.0446L16.9904 35.2829L16.9755 35.2978Z",
    fill: "url(#paint23_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M10.3594 36.3021C10.3594 35.9297 10.6052 35.6243 10.9478 35.5275C11.0595 35.4977 11.1414 35.4083 11.1787 35.2966C11.2829 34.9465 11.6181 34.6933 12.0129 34.7231C12.4002 34.7529 12.7204 35.0657 12.7577 35.453C12.7577 35.5126 12.7577 35.5796 12.7577 35.6318C12.7428 35.7509 12.7949 35.8775 12.8992 35.9446C13.1152 36.0861 13.2641 36.3393 13.2641 36.6224C13.2641 36.8458 13.1673 37.0543 13.0184 37.2033C12.9662 37.2554 12.9215 37.3076 12.8992 37.3746C12.8098 37.5832 12.6087 37.7247 12.3704 37.7247C12.348 37.7247 12.3182 37.7247 12.2959 37.7247C12.1618 37.7098 12.0352 37.7247 11.9235 37.7992C11.8043 37.8736 11.6553 37.9183 11.5064 37.9183C11.0595 37.9183 10.702 37.5534 10.702 37.1139C10.702 37.032 10.6722 36.9575 10.6201 36.9054C10.4711 36.7564 10.3743 36.5553 10.3743 36.3319L10.3594 36.3021Z",
    fill: "url(#paint24_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M11.1952 36.7868C11.1952 36.7868 11.2101 36.8389 11.2176 36.8613C11.225 36.8836 11.2399 36.906 11.2548 36.9283C11.2697 36.9507 11.292 36.9656 11.3144 36.9805C11.3367 36.9954 11.3591 37.0028 11.3814 37.0177L11.5006 37.0773C11.5006 37.0773 11.4931 37.0624 11.4931 37.0549C11.4857 37.0251 11.4782 37.0028 11.4708 36.9805C11.4708 36.9805 11.4857 37.0326 11.4931 37.0549C11.4931 37.0698 11.5006 37.0773 11.508 37.0847H11.5155C11.5155 37.0847 11.5155 37.0922 11.5155 37.0996C11.5155 37.0996 11.5155 37.1071 11.5229 37.1145C11.5378 37.1369 11.5602 37.1518 11.5825 37.1667C11.6049 37.1816 11.6272 37.189 11.6495 37.2039L11.7762 37.2709V36.541L11.7985 37.4944L11.873 37.4571C11.873 37.4571 11.9326 37.4273 11.9549 37.3975C11.9773 37.3752 11.9996 37.3454 12.0071 37.3156C12.0071 37.3007 12.0145 37.2858 12.022 37.2635C12.022 37.2486 12.0368 37.2337 12.0517 37.2188C12.0666 37.2039 12.0815 37.2039 12.0964 37.1964C12.1113 37.1964 12.1337 37.189 12.1486 37.1816C12.1784 37.1741 12.2082 37.1443 12.2156 37.1145C12.2305 37.0475 12.2454 36.9805 12.2677 36.9134C12.2528 36.9805 12.2379 37.0475 12.2231 37.1145C12.2156 37.1443 12.1858 37.1741 12.156 37.189C12.1411 37.189 12.1262 37.1965 12.1039 37.2039C12.089 37.2039 12.0741 37.2113 12.0592 37.2262C12.0443 37.2337 12.0368 37.2486 12.0294 37.2635C12.0294 37.2784 12.022 37.2933 12.0145 37.3156C11.9996 37.3454 11.9847 37.3827 11.9624 37.405C11.94 37.4273 11.9102 37.4497 11.8804 37.4646L11.7985 37.5093L11.8283 39.416C11.8283 39.416 11.806 39.4607 11.7836 39.4607C11.7613 39.4607 11.7389 39.4383 11.7389 39.416L11.7687 37.2784L11.6347 37.2039C11.6347 37.2039 11.59 37.1816 11.5602 37.1667C11.5378 37.1518 11.5155 37.1294 11.5006 37.1071L11.4931 37.0922L11.3516 37.0177C11.3516 37.0177 11.3069 36.9954 11.2771 36.9805C11.2548 36.9656 11.2325 36.9432 11.2176 36.9209C11.2027 36.8985 11.1878 36.8762 11.1803 36.8464C11.1729 36.824 11.1654 36.7943 11.158 36.7719L11.1952 36.7868Z",
    fill: "url(#paint25_linear_2881_52665)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M27.1421 34.5375C27.1421 33.964 26.7548 33.4799 26.226 33.3309C26.0547 33.2788 25.9206 33.1447 25.8685 32.9734C25.7046 32.4297 25.1833 32.0349 24.5725 32.0796C23.9618 32.1243 23.4702 32.6084 23.4106 33.2117C23.4031 33.3086 23.4106 33.4054 23.4106 33.4948C23.4329 33.681 23.351 33.8746 23.1872 33.9789C22.8445 34.2023 22.6211 34.5896 22.6211 35.0291C22.6211 35.3791 22.7626 35.6994 23.0009 35.9303C23.0754 36.0048 23.1499 36.0942 23.1872 36.191C23.3212 36.5113 23.6415 36.7347 24.0139 36.7347C24.0511 36.7347 24.0884 36.7347 24.1331 36.7347C24.3342 36.7049 24.5427 36.7421 24.714 36.8464C24.9002 36.9581 25.1237 37.0252 25.362 37.0252C26.0547 37.0252 26.6207 36.4591 26.6207 35.7664C26.6207 35.6324 26.6654 35.5207 26.7548 35.4387C26.9857 35.2078 27.1347 34.895 27.1347 34.545L27.1421 34.5375Z",
    fill: "url(#paint26_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M25.8466 35.2978C25.8317 35.3351 25.8243 35.3798 25.8094 35.417C25.7945 35.4542 25.7721 35.4915 25.7498 35.5213C25.7274 35.5511 25.6902 35.5809 25.6604 35.6032C25.6306 35.6255 25.5859 35.6404 25.5487 35.6628L25.3625 35.7522C25.3625 35.7522 25.3774 35.7298 25.3774 35.7149C25.3923 35.6777 25.3997 35.633 25.4072 35.5957L25.4742 35.35L25.3997 35.5883C25.3848 35.6255 25.3774 35.6702 25.3625 35.7075C25.3625 35.7224 25.3476 35.7447 25.3401 35.7596H25.3252V35.7671C25.3178 35.7671 25.3178 35.782 25.3252 35.7894C25.3252 35.7968 25.3178 35.8043 25.3103 35.8117C25.288 35.8415 25.2508 35.8713 25.221 35.8937C25.1837 35.916 25.1465 35.9309 25.1092 35.9533L24.9081 36.0501L24.8933 34.918L24.8709 36.4001L24.7592 36.3406C24.7145 36.3182 24.6698 36.2884 24.6326 36.2512C24.5953 36.2139 24.5655 36.1693 24.5506 36.1246C24.5432 36.1022 24.5357 36.0799 24.5283 36.0501C24.5208 36.0203 24.4985 35.9979 24.4762 35.9831C24.4538 35.9682 24.424 35.9533 24.4017 35.9458C24.3793 35.9458 24.3495 35.9309 24.3272 35.9235C24.2825 35.9086 24.2378 35.8639 24.2229 35.8192C24.1931 35.7149 24.1708 35.6106 24.1484 35.5138C24.1708 35.6181 24.1931 35.7224 24.2155 35.8266C24.2304 35.8788 24.2751 35.9235 24.3272 35.9384C24.357 35.9458 24.3793 35.9533 24.4017 35.9607C24.424 35.9607 24.4538 35.9756 24.4687 35.9905C24.4911 36.0054 24.5059 36.0277 24.5134 36.0501C24.5208 36.0724 24.5283 36.1022 24.5357 36.1246C24.5506 36.1767 24.5804 36.2214 24.6177 36.2661C24.6549 36.3033 24.6996 36.3406 24.7517 36.3629L24.8784 36.4299L24.8337 39.4017C24.8337 39.439 24.8635 39.4688 24.9007 39.4688C24.9379 39.4688 24.9677 39.439 24.9677 39.4017L24.923 36.0799L25.139 35.9682C25.139 35.9682 25.2135 35.9309 25.2508 35.9086C25.288 35.8862 25.3178 35.8564 25.3401 35.8192C25.3401 35.8117 25.355 35.8043 25.355 35.7894L25.5785 35.6702C25.5785 35.6702 25.653 35.633 25.6902 35.6106C25.7274 35.5883 25.7572 35.5585 25.7796 35.5213C25.8019 35.484 25.8243 35.4468 25.8392 35.4095C25.8541 35.3723 25.8615 35.3276 25.869 35.2904L25.936 35.0446L25.8615 35.2829L25.8466 35.2978Z",
    fill: "url(#paint27_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M19.2305 36.3021C19.2305 35.9297 19.4763 35.6243 19.8189 35.5275C19.9306 35.4977 20.0125 35.4083 20.0498 35.2966C20.154 34.9465 20.4892 34.6933 20.884 34.7231C21.2713 34.7529 21.5915 35.0657 21.6288 35.453C21.6288 35.5126 21.6288 35.5796 21.6288 35.6318C21.6139 35.7509 21.666 35.8775 21.7703 35.9446C21.9863 36.0861 22.1352 36.3393 22.1352 36.6224C22.1352 36.8458 22.0384 37.0543 21.8895 37.2033C21.8373 37.2554 21.7926 37.3076 21.7703 37.3746C21.6809 37.5832 21.4798 37.7247 21.2415 37.7247C21.2191 37.7247 21.1893 37.7247 21.167 37.7247C21.0329 37.7098 20.9063 37.7247 20.7946 37.7992C20.6754 37.8736 20.5264 37.9183 20.3775 37.9183C19.9306 37.9183 19.5656 37.5534 19.5656 37.1139C19.5656 37.032 19.5358 36.9575 19.4837 36.9054C19.3347 36.7564 19.2379 36.5553 19.2379 36.3319L19.2305 36.3021Z",
    fill: "url(#paint28_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M20.0663 36.7868C20.0663 36.7868 20.0812 36.8389 20.0886 36.8613C20.0961 36.8836 20.111 36.906 20.1259 36.9283C20.1408 36.9507 20.1631 36.9656 20.1855 36.9805C20.2078 36.9954 20.2302 37.0028 20.2525 37.0177L20.3717 37.0773C20.3717 37.0773 20.3642 37.0624 20.3642 37.0549C20.3568 37.0251 20.3493 37.0028 20.3419 36.9805C20.3419 36.9805 20.3568 37.0326 20.3642 37.0549C20.3642 37.0698 20.3717 37.0773 20.3791 37.0847H20.3866C20.3866 37.0847 20.3866 37.0922 20.3866 37.0996C20.3866 37.0996 20.3866 37.1071 20.394 37.1145C20.4089 37.1369 20.4313 37.1518 20.4536 37.1667C20.476 37.1816 20.4983 37.189 20.5206 37.2039L20.6473 37.2709V36.541L20.6696 37.4944L20.7441 37.4571C20.7441 37.4571 20.8037 37.4273 20.826 37.3975C20.8484 37.3752 20.8707 37.3454 20.8782 37.3156C20.8782 37.3007 20.8856 37.2858 20.893 37.2635C20.893 37.2486 20.9079 37.2337 20.9228 37.2188C20.9377 37.2039 20.9526 37.2039 20.9675 37.1964C20.9824 37.1964 21.0048 37.189 21.0197 37.1816C21.0495 37.1741 21.0792 37.1443 21.0867 37.1145C21.1016 37.0475 21.1165 36.9805 21.1388 36.9134C21.1239 36.9805 21.109 37.0475 21.0941 37.1145C21.0867 37.1443 21.0569 37.1741 21.0271 37.189C21.0122 37.189 20.9973 37.1965 20.975 37.2039C20.9601 37.2039 20.9452 37.2113 20.9303 37.2262C20.9154 37.2337 20.9079 37.2486 20.9005 37.2635C20.9005 37.2784 20.893 37.2933 20.8856 37.3156C20.8707 37.3454 20.8558 37.3827 20.8335 37.405C20.8111 37.4273 20.7813 37.4497 20.7515 37.4646L20.6696 37.5093L20.6994 39.416C20.6994 39.416 20.6771 39.4607 20.6547 39.4607C20.6324 39.4607 20.61 39.4383 20.61 39.416L20.6398 37.2784L20.5057 37.2039C20.5057 37.2039 20.4611 37.1816 20.4313 37.1667C20.4089 37.1518 20.3866 37.1294 20.3717 37.1071L20.3642 37.0922L20.2227 37.0177C20.2227 37.0177 20.1706 36.9954 20.1482 36.9805C20.1259 36.9656 20.1035 36.9432 20.0886 36.9209C20.0738 36.8985 20.0589 36.8762 20.0514 36.8464C20.044 36.824 20.0365 36.7943 20.0291 36.7719L20.0663 36.7868Z",
    fill: "url(#paint29_linear_2881_52665)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M36.0132 34.5375C36.0132 33.964 35.6259 33.4799 35.0971 33.3309C34.9258 33.2788 34.7917 33.1447 34.7396 32.9734C34.5757 32.4297 34.0543 32.0349 33.4436 32.0796C32.8329 32.1243 32.3413 32.6084 32.2817 33.2117C32.2742 33.3086 32.2817 33.4054 32.2817 33.4948C32.304 33.681 32.2221 33.8746 32.0582 33.9789C31.7156 34.2023 31.4922 34.5896 31.4922 35.0291C31.4922 35.3791 31.6337 35.6994 31.872 35.9303C31.9465 36.0048 32.021 36.0942 32.0582 36.191C32.1923 36.5113 32.5126 36.7347 32.885 36.7347C32.9222 36.7347 32.9595 36.7347 33.0042 36.7347C33.2053 36.7049 33.4138 36.7421 33.5851 36.8464C33.7713 36.9581 33.9948 37.0252 34.2331 37.0252C34.9258 37.0252 35.4918 36.4591 35.4918 35.7664C35.4918 35.7664 35.4918 35.7664 35.4918 35.759C35.4918 35.6398 35.5365 35.5281 35.6259 35.4387C35.8568 35.2078 36.0058 34.895 36.0058 34.545L36.0132 34.5375Z",
    fill: "url(#paint30_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M34.6883 35.417C34.6734 35.4542 34.651 35.4915 34.6287 35.5213C34.6063 35.5511 34.5691 35.5809 34.5393 35.6032C34.5095 35.6255 34.4648 35.6404 34.4276 35.6628L34.2414 35.7522C34.2414 35.7522 34.2563 35.7298 34.2563 35.7149C34.2712 35.6777 34.2786 35.633 34.2861 35.5957L34.3531 35.35L34.2786 35.5883C34.2637 35.6255 34.2563 35.6702 34.2414 35.7075C34.2414 35.7224 34.2265 35.7447 34.219 35.7596H34.2041V35.7671C34.1967 35.7671 34.1967 35.782 34.2041 35.7894C34.2041 35.7968 34.1967 35.8043 34.1893 35.8117C34.1669 35.8415 34.1297 35.8713 34.0999 35.8937C34.0701 35.916 34.0254 35.9309 33.9882 35.9533L33.7871 36.0501L33.7722 34.918L33.7498 36.4001L33.6381 36.3406C33.5934 36.3182 33.5487 36.2884 33.5115 36.2512C33.4742 36.2139 33.4444 36.1693 33.4295 36.1246C33.4221 36.1022 33.4146 36.0799 33.4072 36.0501C33.3997 36.0203 33.3774 35.9979 33.3551 35.9831C33.3327 35.9682 33.3029 35.9533 33.2806 35.9458C33.2582 35.9458 33.2284 35.9309 33.2061 35.9235C33.1614 35.9086 33.1167 35.8639 33.1018 35.8192C33.072 35.7149 33.0497 35.6106 33.0273 35.5138C33.0497 35.6181 33.072 35.7224 33.0944 35.8266C33.1093 35.8788 33.154 35.9235 33.2061 35.9384C33.2284 35.9458 33.2582 35.9533 33.2806 35.9607C33.3029 35.9607 33.3253 35.9756 33.3476 35.9905C33.37 36.0054 33.3849 36.0277 33.3923 36.0501C33.3923 36.0724 33.4072 36.1022 33.4146 36.1246C33.4295 36.1767 33.4593 36.2214 33.4966 36.2661C33.5338 36.3033 33.5785 36.3406 33.6306 36.3629L33.7573 36.4299L33.7424 37.6887C33.7424 37.6887 33.7945 37.644 33.8243 37.6291L33.8019 36.0873L34.0179 35.9756C34.0179 35.9756 34.0924 35.9384 34.1297 35.916C34.1669 35.8937 34.1967 35.8639 34.219 35.8266C34.219 35.8192 34.2339 35.8117 34.2339 35.7968L34.4574 35.6777C34.4574 35.6777 34.5319 35.6404 34.5691 35.6181C34.6063 35.5957 34.6361 35.566 34.6585 35.5287C34.6808 35.4915 34.7032 35.4542 34.7181 35.417C34.733 35.3798 34.7404 35.3351 34.7479 35.2978L34.8149 35.052L34.7404 35.2904C34.7255 35.3276 34.7181 35.3723 34.7032 35.4095L34.6883 35.417Z",
    fill: "url(#paint31_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M28.1094 36.3021C28.1094 35.9297 28.3552 35.6243 28.6978 35.5275C28.8095 35.4977 28.8914 35.4083 28.9287 35.2966C29.0329 34.9465 29.3681 34.6933 29.7629 34.7231C30.1502 34.7529 30.4704 35.0657 30.5077 35.453C30.5077 35.5126 30.5077 35.5796 30.5077 35.6318C30.4928 35.7509 30.5449 35.8775 30.6492 35.9446C30.8652 36.0861 31.0141 36.3393 31.0141 36.6224C31.0141 36.8458 30.9173 37.0543 30.7684 37.2033C30.7162 37.2554 30.6715 37.3076 30.6492 37.3746C30.5598 37.5832 30.3587 37.7247 30.1204 37.7247C30.098 37.7247 30.0682 37.7247 30.0459 37.7247C29.9118 37.7098 29.7852 37.7247 29.6735 37.7992C29.5543 37.8736 29.4053 37.9183 29.2564 37.9183C28.8095 37.9183 28.4445 37.5534 28.4445 37.1139C28.4445 37.032 28.4147 36.9575 28.3626 36.9054C28.2136 36.7564 28.1168 36.5553 28.1168 36.3319L28.1094 36.3021Z",
    fill: "url(#paint32_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M28.9374 36.7868C28.9374 36.7868 28.9523 36.8389 28.9597 36.8613C28.9672 36.8836 28.9821 36.906 28.997 36.9283C29.0119 36.9507 29.0342 36.9656 29.0566 36.9805C29.0789 36.9954 29.1013 37.0028 29.1236 37.0177L29.2428 37.0773C29.2428 37.0773 29.2353 37.0624 29.2353 37.0549C29.2279 37.0251 29.2204 37.0028 29.213 36.9805C29.213 36.9805 29.2279 37.0326 29.2353 37.0549C29.2353 37.0698 29.2428 37.0773 29.2502 37.0847H29.2577C29.2577 37.0847 29.2577 37.0922 29.2577 37.0996C29.2577 37.0996 29.2577 37.1071 29.2651 37.1145C29.28 37.1369 29.3024 37.1518 29.3247 37.1667C29.347 37.1816 29.3694 37.189 29.3917 37.2039L29.5184 37.2709V36.541L29.5407 37.4944L29.6152 37.4571C29.6152 37.4571 29.6748 37.4273 29.6971 37.3975C29.7194 37.3752 29.7418 37.3454 29.7492 37.3156C29.7492 37.3007 29.7567 37.2858 29.7641 37.2635C29.7641 37.2486 29.779 37.2337 29.7939 37.2188C29.8088 37.2039 29.8237 37.2039 29.8386 37.1964C29.8535 37.1964 29.8759 37.189 29.8908 37.1816C29.9206 37.1741 29.9503 37.1443 29.9578 37.1145C29.9727 37.0475 29.9876 36.9805 30.0099 36.9134C29.995 36.9805 29.9801 37.0475 29.9652 37.1145C29.9578 37.1443 29.928 37.1741 29.8982 37.189C29.8833 37.189 29.8684 37.1965 29.8461 37.2039C29.8312 37.2039 29.8163 37.2113 29.8014 37.2262C29.7865 37.2337 29.779 37.2486 29.7716 37.2635C29.7716 37.2784 29.7641 37.2933 29.7567 37.3156C29.7418 37.3454 29.7269 37.3827 29.7046 37.405C29.6822 37.4273 29.6524 37.4497 29.6226 37.4646L29.5407 37.5093L29.5705 39.416C29.5705 39.416 29.5481 39.4607 29.5258 39.4607C29.5035 39.4607 29.4811 39.4383 29.4811 39.416L29.5109 37.2784L29.3768 37.2039C29.3768 37.2039 29.3247 37.1816 29.3024 37.1667C29.28 37.1518 29.2577 37.1294 29.2428 37.1071C29.2428 37.1071 29.2428 37.0922 29.2353 37.0922L29.0938 37.0177C29.0938 37.0177 29.0491 36.9954 29.0193 36.9805C28.997 36.9656 28.9746 36.9432 28.9597 36.9209C28.9448 36.8985 28.93 36.8762 28.9225 36.8464C28.9151 36.824 28.9076 36.7943 28.9002 36.7719L28.9374 36.7868Z",
    fill: "url(#paint33_linear_2881_52665)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M5.82569 18.7912C5.7959 18.7092 5.72141 18.6571 5.63204 18.6497L4.86488 18.6348C4.71592 18.6348 4.56695 18.6646 4.43289 18.7241L1.75901 19.9009C1.69198 19.9307 1.61005 19.9307 1.54301 19.9009L1.32702 19.7892C1.26743 19.7594 1.19295 19.7594 1.13337 19.7892L1.05889 19.8265C0.9993 19.8563 0.991852 19.9307 1.03654 19.9754L1.49088 20.4149C1.55791 20.4819 1.65474 20.4968 1.74411 20.467L2.69747 20.1169L4.28393 19.5807L5.70652 19.0668C5.81824 19.0295 5.87038 18.9029 5.83314 18.7986L5.82569 18.7912Z",
    fill: "url(#paint34_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M4.33632 19.5515L2.0274 18.5534C1.93802 18.5162 1.83375 18.5087 1.73693 18.546C1.66989 18.5683 1.655 18.6577 1.70713 18.6949L3.22655 19.9239",
    fill: "url(#paint35_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M32.9531 21.9945H35.6121C35.7313 21.9945 35.8281 21.8977 35.8281 21.7785C35.8281 21.6593 35.7313 21.5625 35.6121 21.5625H32.9531V21.9945Z",
    fill: "url(#paint36_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M32.9531 23.2308H35.6121C35.7313 23.2308 35.8281 23.134 35.8281 23.0148C35.8281 22.8957 35.7313 22.7988 35.6121 22.7988H32.9531V23.2308Z",
    fill: "url(#paint37_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M26.6406 32.4C26.6406 32.4 27.0503 32.7873 28.6963 32.3554L28.5399 31.834",
    fill: "url(#paint38_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M28.2739 28.2577V27.5129C28.2739 27.3937 28.1771 27.2969 28.0579 27.2969H27.8941C27.7749 27.2969 27.6781 27.3937 27.6781 27.5129V28.2577C27.6781 28.5482 27.5589 28.8237 27.3727 29.0397C27.2982 29.1291 27.2461 29.2483 27.2461 29.3824V32.3914C27.2461 32.6819 27.4844 32.9202 27.7749 32.9202H28.1771C28.4676 32.9202 28.7059 32.6819 28.7059 32.3914V29.3824C28.7059 29.2557 28.6612 29.1366 28.5793 29.0397C28.3931 28.8163 28.2739 28.5482 28.2739 28.2577Z",
    fill: "url(#paint39_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M28.5494 30.886C28.5494 30.5657 28.2887 30.3125 27.9759 30.3125C27.663 30.3125 27.4023 30.5732 27.4023 30.886C27.4023 31.1988 27.663 31.4595 27.9759 31.4595C28.2887 31.4595 28.5494 31.1988 28.5494 30.886Z",
    fill: "url(#paint40_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M26.6131 31.2451C26.6131 31.2451 27.3654 31.4611 27.3058 30.4184C27.2909 30.2098 27.6409 30.2173 27.6633 30.4258L27.7452 31.1408C27.8346 31.9452 27.0749 32.5932 26.3003 32.3474C26.1737 32.3102 26.0396 32.2506 25.8906 32.1836L26.6131 31.2451Z",
    fill: "url(#paint41_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M28.585 30.7227H28.436C28.2427 30.7227 28.0859 30.8794 28.0859 31.0727V32.0037C28.0859 32.1971 28.2427 32.3538 28.436 32.3538H28.585C28.7783 32.3538 28.935 32.1971 28.935 32.0037V31.0727C28.935 30.8794 28.7783 30.7227 28.585 30.7227Z",
    fill: "url(#paint42_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M18.2422 24.5938C18.2422 24.5938 20.1042 26.1802 21.2661 28.72C22.428 31.2673 26.8671 31.2524 26.8671 31.2524C26.8671 31.2524 26.8969 32.4366 26.5766 32.4143C26.5766 32.4143 22.3982 33.0772 19.8882 30.7161",
    fill: "url(#paint43_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M16.9071 23.7441H18.6202C18.8511 23.7441 19.0447 23.9303 19.0447 24.1687C19.0447 24.3996 18.8585 24.5932 18.6202 24.5932H18.5085C18.4489 24.5932 18.4117 24.6603 18.4489 24.7049C19.2682 25.9562 26.2545 37.0316 13.6597 34.9461L13.332 25.0178L13.5927 23.7516H16.9071V23.7441Z",
    fill: "url(#paint44_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M14.5159 24.2366C14.5159 24.2366 14.5159 24.5643 13.5625 24.5867C13.5625 24.5867 14.6425 27.5287 15.8193 27.7521C16.9961 27.9756 17.9792 27.0595 17.9792 27.0595L18.091 26.0093L17.5324 24.5941C17.5324 24.5941 16.6758 24.542 16.6237 23.9238C16.5715 23.3056 16.1023 23.0449 16.1023 23.0449",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M16.6172 23.9159C16.5725 23.4243 16.2746 23.1636 16.148 23.0742L15.8277 23.2455L14.6211 24.1542C14.6956 24.4372 14.9637 24.8469 15.8873 24.8618C17.2875 24.8841 17.9281 25.8151 17.8461 26.5078C17.7642 27.2005 17.429 27.3048 17.429 27.3048C17.429 27.3048 17.0715 27.3122 17.2577 26.9026C17.4439 26.4929 16.215 26.5227 16.4012 26.7908C16.5874 27.0515 17.2503 27.5654 16.3863 27.3271C15.8351 27.1781 15.7905 27.4984 15.8277 27.7591C17.0045 27.9676 17.9728 27.059 17.9728 27.059L18.0845 26.0088L17.5259 24.5936C17.5259 24.5936 16.6693 24.5415 16.6172 23.9233V23.9159Z",
    fill: "url(#paint45_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M13.3926 19.5742L12.7818 21.7491C12.7595 21.8385 12.7818 21.9353 12.8488 22.0023C12.9233 22.0768 12.968 22.1811 12.9755 22.2928C12.9829 22.5907 13.0574 23.2015 13.5341 23.2015C14.1597 23.2015 14.5023 23.693 14.5321 24.2368L16.5431 23.9314C16.5431 23.9314 16.8932 20.8851 15.6717 19.9392C14.4502 18.9933 13.4075 19.5668 13.4075 19.5668L13.3926 19.5742Z",
    fill: "#F9AA8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M12.7727 21.8684C12.8099 21.8684 12.9664 21.8833 12.9962 21.7864C13.0259 21.6747 13.3164 20.9374 13.2568 20.9076C13.2196 20.8852 13.1153 20.8033 13.0557 20.7586L13.3909 19.5744C13.3909 19.5744 13.4281 19.552 13.4728 19.5371L13.9123 19.5892L15.6998 19.9914C16.2137 20.4309 16.4297 21.2651 16.5191 22.0471C16.5191 22.0471 16.5191 22.062 16.5191 22.0695C16.5191 22.1067 16.5266 22.144 16.5266 22.1812C16.5266 22.2482 16.534 22.3153 16.5415 22.3823C16.5415 22.3972 16.5415 22.4046 16.5415 22.4195C16.5415 22.4493 16.5415 22.4791 16.5415 22.5089C16.5415 22.5238 16.5415 22.5462 16.5415 22.5611C16.5415 22.5983 16.5415 22.6355 16.5415 22.6728C16.5415 22.7026 16.5415 22.7249 16.5415 22.7547C16.5415 22.777 16.5415 22.7994 16.5415 22.8143C16.5415 22.8366 16.5415 22.8664 16.5415 22.8888C16.5415 22.9037 16.5415 22.926 16.5415 22.9409C16.5415 22.9781 16.5415 23.0228 16.5415 23.0601C16.5415 23.075 16.5415 23.0824 16.5415 23.0973C16.5415 23.1271 16.5415 23.1569 16.5415 23.1867C16.5415 23.2016 16.5415 23.209 16.5415 23.2239C16.5415 23.2612 16.5415 23.291 16.5415 23.3208V23.3282L16.5042 23.939C16.5042 23.939 16.3478 23.9613 16.3404 23.9613L16.1691 23.9836C15.4242 24.0954 14.6869 23.857 14.0985 23.3952C13.9942 23.3133 13.8676 23.2537 13.7261 23.2239C13.7261 23.2239 13.7857 23.2239 13.8154 23.2165C14.6869 23.0526 14.6645 21.2278 13.5995 21.3172C12.9962 21.3694 12.944 22.2929 12.944 22.2929C12.944 22.2482 12.9366 22.2035 12.9217 22.1663C12.9068 22.1291 12.8919 22.0844 12.8621 22.0546C12.8472 22.0397 12.8397 22.0173 12.8248 22.0024C12.7876 21.9652 12.7653 21.9205 12.7578 21.8684H12.7727Z",
    fill: "url(#paint46_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M17.4273 36.7419C15.7068 36.7419 14.7683 36.3173 14.314 36.012C13.9714 35.7811 13.8075 35.6247 13.4128 35.498C12.6828 36.6227 12.4073 37.9932 12.7126 39.2966C12.8095 39.7062 12.9733 40.101 13.1595 40.4883C14.962 41.2108 16.8836 41.7023 18.8871 41.896C18.6041 40.101 18.1349 38.3358 17.4199 36.7419H17.4273Z",
    fill: "url(#paint47_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M13.9709 36.7788C14.0156 36.4957 14.5966 36.6372 14.5966 36.6372L14.2316 35.9446C13.9411 35.7435 13.7773 35.602 13.4123 35.4902C12.8463 36.3542 12.5558 37.3672 12.593 38.3801C12.6824 38.3131 12.7941 38.2609 12.9282 38.2162C13.9337 37.9034 13.9262 37.0618 13.9709 36.7713V36.7788Z",
    fill: "url(#paint48_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M19.8552 35.5055C19.0583 36.4886 18.0453 36.7717 17.0845 36.7419L17.025 36.7791C17.1665 38.3432 17.0622 39.9744 16.8164 41.5832C17.8442 41.7917 18.9019 41.9258 19.9819 41.9779C20.5554 38.1794 19.9148 35.498 19.9148 35.498L19.8552 35.5129V35.5055Z",
    fill: "url(#paint49_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M14.6218 23.737C14.458 24.3254 15.1357 24.8021 15.6646 24.4893L17.0946 23.6328C17.6011 23.3274 18.2714 22.7986 18.048 22.3815C17.184 20.7876 18.1448 18.7542 16.0891 18.2552C14.7186 17.9201 13.7355 18.218 13.1024 18.5904C12.5661 18.9032 12.4842 19.648 12.9236 20.08L13.6536 20.8025C13.9664 21.1079 14.4207 21.2196 14.8378 21.093C15.2251 20.9738 15.7241 20.8844 15.8135 21.2792C15.9848 22.024 15.3592 21.7037 14.6442 23.67C14.6367 23.6924 14.6293 23.7147 14.6218 23.737Z",
    fill: "url(#paint50_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M14.3357 33.5839L13.293 35.6917C13.293 35.6917 14.9316 37.4197 17.5458 37.3601C20.2123 37.3005 20.0559 36.1088 20.0559 36.1088C20.0559 36.1088 19.9293 34.4702 18.6482 33.0625",
    fill: "url(#paint51_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M19.2683 32.1089C19.0746 31.8929 19.0448 31.6248 18.9852 31.4311C18.8512 31.0066 18.9778 30.5448 19.2757 30.2096C19.6109 29.8372 19.9833 29.0477 19.1193 27.6698C18.8512 27.2378 18.5979 26.7984 18.3745 26.3441L17.5254 24.5938C17.5254 24.5938 18.4564 27.141 17.1977 27.3942C15.641 27.7071 13.8013 25.1375 13.5556 24.5938C13.5556 24.5938 15.0675 28.0571 14.1886 29.2488C14.1291 29.3308 14.1216 29.435 14.1738 29.517L14.6951 30.2916C15.0303 30.798 15.0154 31.6024 14.6504 32.0866C13.2576 33.9412 11.8648 34.8722 16.6167 36.2948C19.2981 37.0992 21.4655 34.5817 19.2608 32.1089H19.2683Z",
    fill: "url(#paint52_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M19.5889 29.6439C19.5889 29.6439 19.425 30.0833 18.7919 30.0387C18.1514 29.994 16.9448 30.0908 16.2074 30.0387C15.4701 29.9865 15.1349 29.696 15.0679 29.0853C15.0381 28.8097 14.7327 28.7203 14.4199 28.7129C14.3752 28.914 14.3081 29.0927 14.1964 29.2343C14.1368 29.3162 14.1294 29.4205 14.1815 29.5024L14.7029 30.277C15.0381 30.7835 15.0232 31.5879 14.6582 32.072C14.2858 32.571 13.9134 32.9956 13.6602 33.3903V34.9321L13.6825 34.9544C14.0102 35.2747 14.6061 35.5875 15.5669 35.9301C15.5296 35.9078 13.6602 34.6044 15.5222 33.7329C17.3991 32.8466 19.0675 30.5079 19.0675 30.5079C19.1196 30.3962 19.1941 30.2919 19.276 30.2025C19.3952 30.0685 19.5218 29.8822 19.5889 29.6365V29.6439Z",
    fill: "url(#paint53_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M13.5926 23.7441H13.7639C13.9948 23.7441 14.1884 23.9303 14.1884 24.1687C14.1884 24.3996 14.0022 24.5932 13.7639 24.5932H13.5628C13.5628 24.5932 16.9517 29.3302 13.6671 34.9461C13.6671 34.9461 11.1794 32.734 11.0304 29.7697C10.9113 27.4086 12.3487 24.9954 12.9371 24.1017C13.0861 23.8782 13.3319 23.7441 13.6 23.7441H13.5926Z",
    fill: "url(#paint54_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M13.6382 25.4274L11.1506 28.1683C11.0463 28.6896 10.9941 29.2259 11.0239 29.7622C11.091 31.0879 11.6272 32.2573 12.1933 33.1511C12.2082 33.1809 12.2305 33.2032 12.2454 33.233C12.2752 33.2851 12.3125 33.3298 12.3423 33.382C12.7891 33.9778 13.5414 33.9927 13.3329 33.5384C13.102 33.0543 12.804 32.2796 13.7872 30.142C14.7703 28.0044 13.6457 25.4199 13.6457 25.4199L13.6382 25.4274Z",
    fill: "url(#paint55_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M13.2939 24.5938C13.2939 24.5938 9.61457 24.7874 9.07086 30.8725C8.75059 34.4625 13.2939 38.0153 13.2939 38.0153C13.2939 38.0153 13.6812 38.0153 13.8749 37.2779C13.8749 37.2779 9.76353 32.6079 12.3257 29.8298C14.8953 27.0442 13.2939 24.5938 13.2939 24.5938Z",
    fill: "url(#paint56_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M11.5901 27.0424L10.9437 27.2199C10.7612 27.2699 10.6539 27.4585 10.704 27.6409L10.8814 28.2874C10.9315 28.4698 11.12 28.5771 11.3025 28.5271L11.9489 28.3496C12.1314 28.2995 12.2387 28.111 12.1886 27.9285L12.0112 27.2821C11.9611 27.0996 11.7726 26.9923 11.5901 27.0424Z",
    fill: "url(#paint57_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M17.011 18.7402C17.659 19.4329 17.1674 20.2745 16.4599 20.0064C15.7523 19.7308 14.6574 19.0754 14.9479 20.215C15.1564 21.0566 14.6946 21.1534 14.4414 21.146C14.5755 21.146 14.7095 21.1311 14.8436 21.0938C15.2309 20.9747 15.7299 20.8853 15.8193 21.28C15.9906 22.0249 15.365 21.7046 14.65 23.6709C14.6425 23.6932 14.6351 23.7156 14.6276 23.7379C14.4638 24.3263 15.1415 24.803 15.6703 24.4902L17.1004 23.6337C17.6069 23.3283 18.2772 22.7995 18.0537 22.3824C17.3685 21.1162 17.8303 19.567 17.0185 18.7402H17.011Z",
    fill: "url(#paint58_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M24.8847 31.8637H23.5813C21.9874 31.8637 20.6914 30.5677 20.6914 28.9738V15.9023H21.3096V28.3556C21.3096 29.9495 22.6056 31.2455 24.1995 31.2455H24.8847V31.8637Z",
    fill: "url(#paint59_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M21.3096 12.4824H20.6914L20.818 11.2088C20.8255 11.1194 20.9074 11.0449 20.9968 11.0449C21.0862 11.0449 21.1681 11.112 21.1755 11.2088L21.3022 12.4824H21.3096Z",
    fill: "url(#paint60_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M10.8463 17.1301C10.891 17.1375 10.9357 17.1375 10.9804 17.1301C11.8667 16.9811 13.0212 16.8992 14.2725 16.8992C15.5238 16.8992 16.6782 16.9885 17.5645 17.1301C17.6092 17.1375 17.6539 17.1375 17.6986 17.1301C18.5849 16.9811 19.7394 16.8992 20.9907 16.8992C22.242 16.8992 23.3964 16.9885 24.2828 17.1301C24.3274 17.1375 24.3721 17.1375 24.4168 17.1301C25.3031 16.9811 26.4576 16.8992 27.7089 16.8992C28.9602 16.8992 30.1146 16.9885 31.001 17.1301C31.0457 17.1375 31.0903 17.1375 31.135 17.1301C31.6787 17.0407 32.3193 16.9736 33.0269 16.9364C33.4588 16.9141 33.6376 16.3927 33.3248 16.1022C30.9935 13.9497 26.3384 12.4824 20.9758 12.4824C15.6131 12.4824 10.9655 13.9497 8.62679 16.1022C8.31396 16.3927 8.49272 16.9141 8.92471 16.9364C9.63228 16.9736 10.2728 17.0407 10.8165 17.1301H10.8463Z",
    fill: "url(#paint61_linear_2881_52665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M22.2638 16.9305C23.0235 16.9678 23.7162 17.0348 24.2971 17.1316C24.3418 17.1391 24.3865 17.1391 24.4312 17.1316C24.9675 17.0423 25.608 16.9827 26.3081 16.938C26.5837 16.9231 26.8667 16.9082 27.1572 16.9082C27.3211 16.7965 27.3806 16.357 27.2391 16.0964C26.0623 13.9438 23.7087 12.4766 21.005 12.4766C18.3014 12.4766 15.9478 13.9438 14.771 16.0964C14.6294 16.357 14.689 16.789 14.8529 16.9082C15.1434 16.9082 15.4264 16.9231 15.702 16.938C16.3947 16.9752 17.0352 17.0423 17.5789 17.1316C17.6236 17.1391 17.6683 17.1391 17.713 17.1316C18.2939 17.0348 18.9866 16.9678 19.7463 16.9305C19.791 16.9305 19.8357 16.9305 19.8804 16.9305C20.2453 16.9156 20.6177 16.9008 21.005 16.9008C21.3923 16.9008 21.7648 16.9082 22.1297 16.9305C22.1744 16.9305 22.2191 16.9305 22.2638 16.9305Z",
    fill: "url(#paint62_linear_2881_52665)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M30.5604 2.30892C27.6929 0.841639 24.4455 0 20.997 0C17.5485 0 14.3011 0.83419 11.4336 2.30892H30.5604Z",
    fill: "url(#paint63_linear_2881_52665)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2881_52665",
    x1: 20.9973,
    y1: 45.3741,
    x2: 20.9973,
    y2: -10.9039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2881_52665",
    x1: 2.55471,
    y1: 12.408,
    x2: 2.55471,
    y2: 5.0716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2881_52665",
    x1: 4.98098,
    y1: 10.7842,
    x2: 4.98098,
    y2: 1.87626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2881_52665",
    x1: 39.4457,
    y1: 12.408,
    x2: 39.4457,
    y2: 5.0716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2881_52665",
    x1: 37.0187,
    y1: 10.7842,
    x2: 37.0187,
    y2: 1.87626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2881_52665",
    x1: 20.997,
    y1: 9.62955,
    x2: 20.997,
    y2: 2.50913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2881_52665",
    x1: 19.7383,
    y1: 8.31867,
    x2: 19.7383,
    y2: -3.69516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2881_52665",
    x1: 19.7375,
    y1: 19.2975,
    x2: 19.7375,
    y2: 3.10527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FF1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2FBCA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F7DA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2881_52665",
    x1: 19.7375,
    y1: 18.8506,
    x2: 19.7375,
    y2: 9.62983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FF1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2FBCA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F7DA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2881_52665",
    x1: 15.8644,
    y1: 6.02521,
    x2: 15.8644,
    y2: -1.43037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2881_52665",
    x1: 15.8644,
    y1: 4.61751,
    x2: 15.8644,
    y2: 0.491251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2881_52665",
    x1: 27.1769,
    y1: 6.02521,
    x2: 27.1769,
    y2: -1.43037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2881_52665",
    x1: 27.1769,
    y1: 4.61751,
    x2: 27.1769,
    y2: 0.491251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDDFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2881_52665",
    x1: 9.14975,
    y1: 20.4382,
    x2: 9.14975,
    y2: 7.13581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2881_52665",
    x1: 22.4662,
    y1: 34.3432,
    x2: 22.4662,
    y2: -25.9271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2881_52665",
    x1: 8.64439,
    y1: 21.629,
    x2: 8.64439,
    y2: 16.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2881_52665",
    x1: 9.55064,
    y1: 21.629,
    x2: 9.55064,
    y2: 16.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2881_52665",
    x1: 7.81752,
    y1: 21.629,
    x2: 7.81752,
    y2: 16.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2881_52665",
    x1: 10.3761,
    y1: 21.629,
    x2: 10.3761,
    y2: 16.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2881_52665",
    x1: 9.09849,
    y1: 22.5599,
    x2: 9.09849,
    y2: 10.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2881_52665",
    x1: 7.14277,
    y1: 37.0326,
    x2: 7.14277,
    y2: 25.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2881_52665",
    x1: 7.28513,
    y1: 36.9811,
    x2: 7.28513,
    y2: 33.1081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2881_52665",
    x1: 16.0142,
    y1: 37.0326,
    x2: 16.0142,
    y2: 25.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2881_52665",
    x1: 16.1562,
    y1: 39.9455,
    x2: 16.1562,
    y2: 30.4863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2881_52665",
    x1: 11.8118,
    y1: 37.9034,
    x2: 11.8118,
    y2: 30.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2881_52665",
    x1: 11.724,
    y1: 39.781,
    x2: 11.724,
    y2: 33.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2881_52665",
    x1: 24.8853,
    y1: 37.0326,
    x2: 24.8853,
    y2: 25.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2881_52665",
    x1: 25.0273,
    y1: 39.9455,
    x2: 25.0273,
    y2: 30.4863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2881_52665",
    x1: 20.6829,
    y1: 37.9034,
    x2: 20.6829,
    y2: 30.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2881_52665",
    x1: 20.5951,
    y1: 39.781,
    x2: 20.5951,
    y2: 33.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2881_52665",
    x1: 33.7639,
    y1: 37.0326,
    x2: 33.7639,
    y2: 25.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2881_52665",
    x1: 33.9062,
    y1: 37.9866,
    x2: 33.9062,
    y2: 32.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2881_52665",
    x1: 29.5618,
    y1: 37.9034,
    x2: 29.5618,
    y2: 30.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2881_52665",
    x1: 29.4662,
    y1: 39.781,
    x2: 29.4662,
    y2: 33.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2881_52665",
    x1: 3.41994,
    y1: 24.8391,
    x2: 3.41994,
    y2: 9.83108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2881_52665",
    x1: 3.2489,
    y1: 19.827,
    x2: 1.6401,
    y2: 14.9783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2881_52665",
    x1: 34.3906,
    y1: 16.3712,
    x2: 34.3906,
    y2: 6.82265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2881_52665",
    x1: 34.3906,
    y1: 16.3711,
    x2: 34.3906,
    y2: 6.82259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2881_52665",
    x1: 27.8547,
    y1: 33.1672,
    x2: 27.5493,
    y2: 31.8414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFB699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2881_52665",
    x1: 27.976,
    y1: 37.0763,
    x2: 27.976,
    y2: 25.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#889C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#377F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2881_52665",
    x1: 0.00065884,
    y1: 27.6833,
    x2: 0.745472,
    y2: 24.7115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#889C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#377F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#203C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2881_52665",
    x1: 28.1549,
    y1: 33.3157,
    x2: 25.332,
    y2: 29.1596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFB699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2881_52665",
    x1: 29.151,
    y1: 31.6686,
    x2: 27.4677,
    y2: 31.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFB699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2881_52665",
    x1: 16.5291,
    y1: 21.3687,
    x2: 27.7013,
    y2: 37.0619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2881_52665",
    x1: 17.2274,
    y1: 49.7605,
    x2: 17.2274,
    y2: 26.9245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2881_52665",
    x1: 16.3565,
    y1: 33.7697,
    x2: 16.3565,
    y2: 24.3851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFB699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2881_52665",
    x1: 18.9757,
    y1: 18.972,
    x2: 12.4856,
    y2: 23.7259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFB699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2881_52665",
    x1: 11.2305,
    y1: 31.2228,
    x2: 20.2352,
    y2: 47.5789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2881_52665",
    x1: 12.1387,
    y1: 36.3244,
    x2: 15.4382,
    y2: 38.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2881_52665",
    x1: 19.6467,
    y1: 30.91,
    x2: 18.239,
    y2: 41.3597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2881_52665",
    x1: 6.65977,
    y1: 15.9984,
    x2: 21.422,
    y2: 24.8543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF3E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2881_52665",
    x1: 15.9966,
    y1: 40.4734,
    x2: 17.5533,
    y2: 30.0162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC19E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFB699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2881_52665",
    x1: 16.7583,
    y1: 41.5233,
    x2: 16.7583,
    y2: 14.4866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F5EDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ADBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2881_52665",
    x1: 19.0303,
    y1: 38.2465,
    x2: 13.9879,
    y2: 25.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F5EDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5ADBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2881_52665",
    x1: 13.0563,
    y1: 22.2098,
    x2: 13.0563,
    y2: 40.8897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2881_52665",
    x1: 21.1013,
    y1: 30.7677,
    x2: 7.62014,
    y2: 28.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2881_52665",
    x1: 7.52165,
    y1: 23.6776,
    x2: 18.8577,
    y2: 39.6017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2881_52665",
    x1: 13.0083,
    y1: 25.062,
    x2: 8.30292,
    y2: 33.3281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF3E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2881_52665",
    x1: 18.6273,
    y1: 27.8567,
    x2: 15.6778,
    y2: 20.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF3E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2881_52665",
    x1: 22.7843,
    y1: 8.18608,
    x2: 22.7843,
    y2: 27.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0D1226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2881_52665",
    x1: 20.9968,
    y1: 8.18484,
    x2: 20.9968,
    y2: 27.3265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0D1226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2881_52665",
    x1: 20.9981,
    y1: 8.43809,
    x2: 20.9981,
    y2: 23.6397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2881_52665",
    x1: 20.9976,
    y1: 12.2457,
    x2: 20.9976,
    y2: 26.7248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000741"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2881_52665",
    x1: 0.000715639,
    y1: 10.5019,
    x2: 0.745529,
    y2: -17.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2881_52665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductHostingTour);
export default __webpack_public_path__ + "static/media/icon_product_hosting_tour.f31a9ef399cb62192db48f077f88e8bc.svg";
export { ForwardRef as ReactComponent };